export default __webpack_public_path__ + "static/media/photo--lg--20.4f61673f.jpg";